module.exports = __webpack_public_path__ + "media/icons/tapicerka-welurowa-unactive@3x-c0c203eb.svg";